import { render, staticRenderFns } from "./TermsInsert.vue?vue&type=template&id=0ca48a1b&scoped=true&"
import script from "./TermsInsert.vue?vue&type=script&lang=js&"
export * from "./TermsInsert.vue?vue&type=script&lang=js&"
import style0 from "./TermsInsert.vue?vue&type=style&index=0&id=0ca48a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca48a1b",
  null
  
)

export default component.exports